/** @format */

const PairingModelActionTypes = {
  SET_PAIRING_MODEL_PARAMETERS: 'SET_PAIRING_MODEL_PARAMETERS',
  SET_PAIRING_MODEL_CREW_COUNT: 'SET_PAIRING_MODEL_CREW_COUNT',
  SET_PAIRING_MODEL_ERROR: 'SET_PAIRING_MODEL_ERROR',
  SET_PAIRING_MODEL_RUNTIME: 'SET_PAIRING_MODEL_RUNTIME',
  SET_PAIRING_MODEL_LOADING: 'SET_PAIRING_MODEL_LOADING',
  SET_SELECTED_PAIRING_MODEL: 'SET_SELECTED_PAIRING_MODEL',

  CLEAR_SELECTED_PAIRING_MODEL_DATA: 'CLEAR_SELECTED_PAIRING_MODEL_DATA',

  RUN_PAIRING_MODEL_START: 'RUN_PAIRING_MODEL_START',
  RUN_PAIRING_MODEL_SUCCESS: 'RUN_PAIRING_MODEL_SUCCESS',
  RUN_PAIRING_MODEL_FAILURE: 'RUN_PAIRING_MODEL_FAILURE',

  GET_PAIRING_MODEL_AVAILABLE_MODELS_START:
    'GET_PAIRING_MODEL_AVAILABLE_MODELS_START',
  GET_PAIRING_MODEL_AVAILABLE_MODELS_SUCCESS:
    'GET_PAIRING_MODEL_AVAILABLE_MODELS_SUCCESS',
  GET_PAIRING_MODEL_AVAILABLE_MODELS_FAILURE:
    'GET_PAIRING_MODEL_AVAILABLE_MODELS_FAILURE',

  GET_SELECTED_PAIRING_MODEL_DATA_START:
    'GET_SELECTED_PAIRING_MODEL_DATA_START',
  GET_SELECTED_PAIRING_MODEL_DATA_SUCCESS:
    'GET_SELECTED_PAIRING_MODEL_DATA_SUCCESS',
  GET_SELECTED_PAIRING_MODEL_DATA_FAILURE:
    'GET_SELECTED_PAIRING_MODEL_DATA_FAILURE',
};

export default PairingModelActionTypes;
